import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=d8359466&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=d8359466&prod&lang=scss"
import style1 from "./MenuItem.vue?vue&type=style&index=1&id=d8359466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8359466",
  null
  
)

export default component.exports